import { ApiResponse } from '@restaurant/types';
import httpClient from '~/http/services/pos';
import { PaymentAccount } from '~/types/Payment';

export type PaymentAccountResponse = {
  paymentAccounts: PaymentAccount[];
};

export const fetchPaymentAccounts = () => {
  return httpClient.get<PaymentAccountResponse>('/api/v2/payment-accounts');
};

export const fetchPaymentAccountRotation = () => {
  return httpClient.get<{ paymentAccountId: string; accountCode: string }>(
    '/api/v2/payment-accounts/rotations'
  );
};

export const fetchPriceRounding = (totalPrice: number) => {
  return httpClient.post<ApiResponse<{ roundingAmount: number }>>(
    '/api/v1/roundings',
    { totalPrice }
  );
};
